import Icon from "../common/Icon";
import { useNavigate } from "react-router-dom";

const ListingComponent = ({ item, onClick }) => {
  const navigate = useNavigate();
  // Format posted date
  const formattedDate = item.postedDate
    ? new Date(item.postedDate).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : null;

  return (
    <div
      // title="Click to view job details"
      className={`flex bg-white  gap-2 lg:gap-6 py-4 px-6   items-center justify-between rounded-[15px]  relative`}
      // onClick={() => navigate(`/careers/${item.slug}`)}
    >
      {/* Left Section - Posted Date */}
      {formattedDate && (
        <div className="hidden md:flex flex-col text-center text-gray-700 w-16 flex-shrink-0 text-secondary">
          <p className="date text-5xl font-bold mb-1">
            {new Date(item.postedDate).getDate()}
          </p>
          <p className="month text-lg uppercase leading-none">
            {new Date(item.postedDate).toLocaleString("en-US", {
              month: "short",
            })}
          </p>
          <p className="year text-lg">
            {new Date(item.postedDate).getFullYear()}
          </p>
        </div>
      )}

      {/* Middle Section */}
      <div className="flex-1  p-3 rounded-md">
        {/* Plus Icon */}
        <div
          className="absolute top-4 right-4 cursor-pointer"
          title="Click to view job details "
          onClick={() => navigate(`/careers/${item.slug}`)}
        >
          <Icon icon="plus" size={30} className="hover:text-orange" />
        </div>

        {/* Content */}
        <div className="flex flex-col gap-1">
          {item.title && (
            <p className="title text-green text-28pt leading-tight">
              {item.title}
            </p>
          )}
          {item.shortDescription && (
            <p className="subtitle text-24pt leading-relaxed font-mono text-secondary line-clamp-2">
              {item.shortDescription}
            </p>
          )}
          {/* Additional job details */}
          <div className="mt-2 flex flex-wrap gap-3 text-sm text-gray-500">
            {item.employmentType && (
              <span className="py-1 text-16pt xl:text-18pt border border-quaternary font-mono text-quaternary rounded-full px-3">
                {item.employmentType}
              </span>
            )}
            {item.joiningTime && (
              <span className="py-1 text-16pt xl:text-18pt border border-quaternary font-mono text-quaternary rounded-full px-3">
                Joining: {item.joiningTime}
              </span>
            )}
            {item.salary && (
              <span className="py-1 text-16pt xl:text-18pt border border-quaternary font-mono text-quaternary rounded-full px-3">
                Salary: {item.salary}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListingComponent;
